import React, { useState } from "react";
import { Modal, Box, Typography, Button, Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import errorIcon from "../../assets/icons/error.png";
import checkIcon from "../../assets/icons/check.png";
import trophyIcon from "../../assets/icons/trophy.png";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material'

const BoothVisitModal = ({ data, handleClose, visitedCount, totalBooths }) => {
    const [step, setStep] = useState(1); // Step 1 = Default, Step 2 = Passport Complete, Step 3 = Raffle Entry
    const navigate = useNavigate();

    if (data === "invalid") {
        return (
            <Modal
                open={true}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Only allow closing if it's NOT a backdrop click
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="booth-visit-modal">
                <Box sx={modalStyle}>
                    <Box sx={{ mb: 3 }}>
                        <img
                            src={errorIcon} // Failure icon (replace if needed)
                            alt={"Error"}
                            style={{ width: 300, height: 300 }}
                        />
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                        Invalid QR Code
                    </Typography>
                    <Typography variant="body1" color="gray" mt={1}>
                        The QR code you scanned is invalid. <br></br> Please try again.
                    </Typography>
                    <Button variant="outlined" fullWidth sx={buttonStyle} onClick={handleClose}>
                        Go Back
                    </Button>
                </Box>
            </Modal>
        );
    }

    return (
        <Modal open={data}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleClose(); // Only allow closing if it's NOT a backdrop click
                }
            }}
            disableEscapeKeyDown={true}
            aria-labelledby="booth-visit-modal">
            <Box sx={modalStyle}>
                {step === 1 && (
                    <>
                        {/* Logo */}
                        <Box
                            component="img"
                            src={data?.logo?.image?.[0]?.url}
                            alt="Booth Logo"
                            sx={logoStyle}
                        />

                        {/* Booth Image */}
                        <Box sx={boothContainerStyle}>
                            <Box
                                component="img"
                                src={data?.boothPhoto?.[0]?.image?.[0]?.url}
                                alt="Booth"
                                sx={boothImageStyle}
                            />
                        </Box>

                        {/* Check Mark */}
                        <CheckCircleIcon sx={checkMarkStyle} />

                        {/* Confirmation */}
                        <Typography variant="h6" fontWeight="bold">
                            You visited the {data?.brandName} Booth!
                        </Typography>

                        {/* <Divider sx={{ my: 2 }} /> */}

                        {/* Visited Booth Counter */}


                        <Typography variant="body2" color="gray" >
                            Visit {Math.max(totalBooths - visitedCount, 0)} more booths to enter the raffle
                        </Typography>

                        {/* Next or Go Back Button */}
                        <Button
                            variant="outlined"
                            fullWidth
                            sx={buttonStyle}
                            onClick={() => (visitedCount >= totalBooths ? setStep(2) : handleClose())}
                        >
                            {visitedCount >= totalBooths ? "Next" : "Next"}
                        </Button>
                    </>
                )}

                {step === 2 && (
                    <>
                        <Typography variant="h5" fontWeight="bold">
                            Passport Complete!
                        </Typography>
                        <Box sx={{ mt: 3, mb: 3 }}>
                            <img
                                src={"https://res.cloudinary.com/dtear00ob/image/upload/v1744350687/projectImages/successgif-ezgif.com-crop-bfc7cfac-aba6-43a3-a7b0-c47182fc8fc2.gif"} // Failure icon (replace if needed)
                                alt={"Trophy"}
                                style={{
                                    width: "80%",
                                    height: "80%",
                                    objectFit: "contain",
                                }}
                            />
                        </Box>
                        <Typography variant="h6" fontWeight="bold" mt={2}>
                            You visited all booths
                        </Typography>
                        <Typography variant="body2" color="gray" mt={1}>
                            Congratulations on completing your passport!
                        </Typography>

                        <Button variant="outlined" fullWidth sx={buttonStyle} onClick={() => setStep(3)}>
                            Next
                        </Button>
                    </>
                )}

                {step === 3 && (
                    <>
                        <Typography variant="h5" fontWeight="bold">
                            Passport Complete!
                        </Typography>
                        <Box sx={{ mt: 3, mb: 3 }}>
                            <img
                                src={"https://res.cloudinary.com/dtear00ob/image/upload/v1744177332/projectImages/giftbox-e2a03437-1d5e-4733-9abd-fe2a315746e5.gif"} // Failure icon (replace if needed)
                                alt={"Trophy"}
                                style={{
                                    width: "30%",
                                    height: "30%",
                                    objectFit: "contain",
                                }}
                            />
                        </Box>
                        <Typography variant="h6" fontWeight="bold" mt={2}>
                            You have earned 1 raffle entry!
                        </Typography>
                        <Typography variant="body2" color="gray" mt={1}>
                            You’ve been added to the event raffle.<br></br> Stay tuned for updates!
                        </Typography>

                        <Button variant="outlined" fullWidth sx={buttonStyle} onClick={() => {
                            navigate("/raffle")
                        }}>
                            Great!
                        </Button>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export const ValidateQRModal = ({ isOpen }) => {
    return (
        <Modal
            open={isOpen}
            disableEscapeKeyDown={true}
            aria-labelledby="booth-visit-modal">
            <Box sx={modalStyle}>
                <img
                    src={"https://res.cloudinary.com/dtear00ob/image/upload/v1744346395/projectImages/qr-code-2121143f-ab19-49c1-ad27-5614cb2c6ab9.gif"} // Failure icon (replace if needed)
                    alt={"loading"}
                    style={{
                        width: "60%",
                        height: "60%",
                        objectFit: "contain",
                    }}
                />
                <Typography variant="h6" fontWeight="bold">
                    Checking QR Code...
                </Typography>
            </Box>
        </Modal>
    )

}
// Styles
const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: 350,
    bgcolor: "white",
    borderRadius: "10px",
    boxShadow: 24,
    textAlign: "center",
    p: 3,
};

const buttonStyle = {
    mt: 2,
    borderRadius: "20px",
};

const logoStyle = {
    width: 130,
    height: "auto",
    position: "absolute",
    top: "-45px",
    left: "50%",
    transform: "translateX(-50%)",
    bgcolor: "white",
    borderRadius: "10px",
    boxShadow: 3,
    p: 1,
    px: 2,
};

const boothContainerStyle = {
    width: "100%",
    //aspectRatio: "1 / 1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px",
    border: "5px solid green",
    overflow: "hidden",
    //mt: 3,
};

const boothImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
};

const checkMarkStyle = {
    fontSize: 70,
    color: "green",
    position: "relative",
    top: "-35px",
    bgcolor: "white",
    borderRadius: "50%",
};

export default BoothVisitModal;
